export const DEPRECATED_PREFERRED_NAME_MESSAGE = '{{PreferredName}} is no longer supported — use {{FirstName}} instead.';

/**
 * True if body contains the deprecated PreferredName liquid token
 * (optional whitespace inside the braces).
 * @param {string} [body]
 * @returns {boolean}
 */
export function hasDeprecatedPreferredNameToken(body = '') {
  return /\{\{\s*PreferredName\s*\}\}/.test(body);
}
